module.exports = {"xliffmergeOptions":{"srcDir":"src/i18n","genDir":"src/i18n","i18nFile":"source.xlf","i18nFormat":"xlf","encoding":"UTF-8","defaultLanguage":"de","languages":["en","nl","pl","fr","tr"],"removeUnusedIds":true,"verbose":false,"quiet":false}}


//////////////////
// WEBPACK FOOTER
// ./xliffmerge.json
// module id = ./xliffmerge.json
// module chunks = main